export enum NearbyOptions {
    UNKNOWN = 0,
    GOOD_SCHOOL = 1,
}
